const partnerApplication = [
    {
        selector: '[data-react="partnerApplication"]',
        path: { filename: 'App' },
    },
];

export { partnerApplication };
